import React, { useState, ReactElement, useEffect, Fragment, CSSProperties, useMemo } from "react";
import { ListFilter, ListSubFilter } from "./listTableType";
import { FONT } from "../../../value/staticValues";
import { 
    StyleSheet, View, Text
} from "react-native";


interface CategorySubFilterItemProps {
    id: number,
    name: string,
    subFilters: ListSubFilter[];
    innerComponent: ReactElement;
    clickCb: Function,
}

function CategorySubFilterItem(props:CategorySubFilterItemProps) {
    const [subFilters, setSubFilters] = useState(props.subFilters);
    useEffect(() => {
        setSubFilters(props.subFilters);
    }, [props]);

    function clickItem(id:number, type:string, code:string) {
        props.clickCb(id, type, code);
    }

    return (
        <View>
            <div style={className.categoryFilterItemContainer}>
                <div style={className.categoryFilterItemRowContainer}>
                    <div style={className.categoryFilterItemComponentContainer}>
                        {props.innerComponent}
                    </div>
                    <div style={className.categoryFilterItemName}>{props.name}</div>
                </div>
                <div style={className.categoryFilterItemRowDivContainer}></div>
                <div style={className.categoryFilterItemRowContainer}>
                    {
                        subFilters.map((filter, index) => {
                            return (
                            <div key={index * 991} style={className.subFilterContainer}>
                                <div style={className.subFilterText} onClick={(e)=>clickItem(filter.id, filter.type, filter.code)}>
                                    {filter.name}
                                </div>
                                <div style={className.subFilterValue} onClick={(e)=>clickItem(filter.id, filter.type, filter.code)}>
                                    {filter.count ? filter.count : 0}
                                </div>
                            </div>
                            );
                        })
                    }
                </div>
            </div>

        </View>
    );
                
}



interface CategorySubFilterProps {
    filters: ListFilter[],
    clickCb: Function
}

function CategorySubFilter(props:CategorySubFilterProps) {
    const [filters, setFilters] = useState(props.filters);
    
    useEffect(() =>{
        setFilters(props.filters);
    }, [props])

    function clickCategoryFilterItem(id:number, type:string, code:string) {
        props.clickCb(type, code);
    }
    return (
        <View style={style.categoryFilterContainer}>
            {
                filters.map((filter:ListFilter, index) => {
                    return <CategorySubFilterItem
                            key={index}
                            id={filter.id} 
                            name={filter.name}
                            subFilters={filter.subFilter || []}
                            innerComponent={filter.innerComponent || <div></div>}
                            clickCb={clickCategoryFilterItem}
                            />
                })
                
            }
        </View>
    )
}



const style = StyleSheet.create({
    topContainer: {

    },
    categoryFilterContainer: {
        flexDirection: "row",
        marginBottom: 21,
    },
    categoryFilterItemCount: {
        marginLeft: 5,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 1.09,
        color: "#797d80"
    },

});

const className = {
    categoryFilterItemContainer: {
        width: "190px",
        height: "110px",
        borderRadius: "8px",
        boxShadow: "5px 5px 8px 0 rgba(79, 95, 216, 0.1)",
        border: "solid 1px #e4e7eb",
        backgroundColor: "#fff",
        display: "flex",
        justitfyContent: "center",
        padding: "20px 10px 20px 20px",
        marginRight: "20px",
    },
    categoryFilterItemName: {
        marginTop: "10px",
        fontFamily: FONT.MEDIUM,
        fontWeight: "500",
        fontSize: "14px",
        color: "#333",
    },
    categoryFilterItemRowContainer: {
        width: "85px",
        textAlign: "center",
    } as CSSProperties,

    subFilterContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "end",
        marginBottom: "8px",
        marginRight: "10px",
    },
    categoryFilterItemComponentContainer: {
        display: "flex",
        justifyContent: "center"
    },
    subFilterText: {
        width: "50px",
        marginRight: "10px",
        fontFamily: FONT.REGULAR,
        fontSize: "12px",
        color: "#5c5c5c",
        cursor: "pointer"
    },
    subFilterValue: {
        fontFamily: FONT.REGULAR,
        fontSize: "12px",
        color: "#0853fb",
        cursor: "pointer"
    },
    categoryFilterItemRowDivContainer: {
        width: "18px",
    }
};

export default CategorySubFilter;
